/**
 * Client-side error reporter — sends errors to the server for Global Admin visibility.
 * Uses a dedicated endpoint that doesn't require a valid JWT (service role inserts),
 * so it works even when the user's session is in a broken state.
 */

function getBrowserInfo() {
  const ua = navigator.userAgent
  return {
    userAgent: ua,
    platform: navigator.platform,
    language: navigator.language,
    online: navigator.onLine,
    cookiesEnabled: navigator.cookieEnabled,
    screenWidth: screen.width,
    screenHeight: screen.height,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  }
}

function serializeError(err) {
  if (typeof err === 'string') return { message: err }
  return {
    message: err.message || String(err),
    name: err.name || 'Error',
    code: err.code || err.error_code || err.__isAuthError ? 'auth_error' : null,
    status: err.status || err.statusCode || null,
    stack: err.stack || null
  }
}

/**
 * Report a client-side error to the server for admin troubleshooting.
 * @param {string} userId - The user's UUID
 * @param {string} context - Short context key, e.g. 'password_change', 'mfa_enrollment', 'auth_callback'
 * @param {Error|string|object} error - The error object, message, or Supabase error
 */
export async function reportClientError(userId, context, error) {
  if (!userId || !context || !error) return

  try {
    await fetch('/api/client-errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId,
        context,
        error: serializeError(error),
        browser: getBrowserInfo(),
        url: window.location.href
      })
    })
  } catch {
    // Error reporting must never break the app
  }
}
